<template>
  <modal 
    @close="$emit('close')"
    class="holidays-modal"
  >
    <h4 slot="title">
      {{ $t('annualLeave') }} 
      <!-- ({{ teamName }}) -->
    </h4>
    <div slot="body" class="holidays-modal-body">
      <img :src="require('@/assets/illustrations/sloth-on-vacations.svg')">
      <p>
        {{ $t('howMuchLeaveDaysYouHaveLeft') }} 
        <strong> {{ question }}</strong>?
      </p>  
      <editable-input
        :ref="'editable-input'"
        v-model="holidaysDaysLeft"
        :title="$t('holidayDaysLeft')"
        :placeholder="$t('egX',{x: '20'})"
        lazy-validation
        :incorrect-value-msg="$t('incorrectValue')"
        :input-type="'number'"
      />
      <footer
        slot="footer"
      >
        <button
          class="clavo-button primary"
          :style="{ marginBottom: '10px' }"
          @click="submitDaysLeft"
        >
          {{ $t('save') }}
        </button>
        <a
          v-if="!$store.state.teamsNotToAskAboutLeaveDays.includes(teamId)"
          class="clavo-link primary"
          @click="remindLater"
        >
          {{ $t('doNotAskMeAgain') }}
        </a>
      </footer>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import EditableInput from '@/components/UI/EditableInput'
import EventBus from '@/EventBus'
import Constants from '@/components/Constants'
import moment from 'moment-timezone'
import ParseFunctions from '@/components/ParseFunctions'
import Parse from 'parse'

export default {
  name: 'HolidaysDaysLeft',
  components: {
    EditableInput,
    Modal
  },
  mixins: [ParseFunctions],
  props: {
    teamId: String,
  },
  data() {
    return{
      holidaysDaysLeft: '',
    }
  },  
  computed: {
    teamName() {
      let currentTeam = this.$store.state.teams.find(team => team.teamId == this.teamId)
      return currentTeam.name
    },
    question() {
      return this.$store.state.teams.length > 1 ? this.$t('inYearXinTeamY', {x: moment().format('YYYY'), y: this.teamName}) : this.$t('inYearX', {x: moment().format('YYYY')})
    }
  },
  mounted() {
    this.$refs['editable-input'].focusIn()
  },
  methods: {
    async submitDaysLeft() {
      if(this.holidaysDaysLeft >= 0 ) {
        let res = await this.getMyTeamMemberId(this.teamId)
        if(res.status === 'ok') {
          let teamMemberId = res.teamMemberId
          let year = moment().format('YYYY')
          res = await this.setHolidayDays(teamMemberId, year, this.holidaysDaysLeft)
          if(res.status === 'ok') {
            let userId = Parse.User.current()._getId()
            let valuesToUpdateHolidayInfo = {
              userId: userId,
              teamId: this.teamId,
              year: year,
              limit: this.holidaysDaysLeft,
            }
            this.$store.commit('updateHolidayInfo', valuesToUpdateHolidayInfo)
            EventBus.$emit('updateHolidayInfo', this.$store.state.holidayInfo[userId].holidayInfo)
          } else {
            this.showServerError(res)
          }
        }
        else {
          this.showServerError(res)
        }

        this.$emit('close')
      }
      else {
        this.$refs['editable-input'].setIncorrect()
      }
    },
    remindLater() {
      this.$store.commit('addTeamIdToTeamsNotToAskAboutLeaveDays', this.teamId)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.holidays-modal {
  z-index: 3000;
  h4 {
    text-transform: capitalize;
    align-self: flex-start;
  }
  .holidays-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    img {
      
      margin-bottom: 36px;
      width: 240px;
    }
    p {
      margin-bottom: 30px;
      font-size: 16px;
      line-height: 24px;
    }
    .editable-input-wrapper {
      width: 60%;
      @include respond-below(xs) {
        width: 100%;
      }
    }
    footer {
      width: 60%;
      @include respond-below(xs) {
        width: 100%;
      }
      button {
        width: 100%;
      }
      a {
        cursor: pointer;
        margin-top: 6px;
        display: block;
        font-size: 14px;
      }
    }
  }

}
</style>